class Accordion extends HTMLElement {
    constructor() {
        super();
        const toggles = this.querySelectorAll('.js-accordion-toggle')
        toggles.forEach((toggle) => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault()
                const target = this.querySelector(toggle.getAttribute('data-target'))
                toggle.classList.toggle('is-active')
                if (target.style.maxHeight) {
                    target.style.maxHeight = null
                } else {
                    target.style.maxHeight = target.scrollHeight + 'px'
                }
            })
        })

        window.addEventListener('resize', function (event) {
            const targets = this.querySelectorAll('.accordion__content')
            targets.forEach((target) => {
                if (target.style.maxHeight) {
                    target.style.maxHeight = target.scrollHeight + 'px'
                }
            })
        })
        

    }
}


customElements.define('accordion-blocks', Accordion);